import { error } from '@/util/console';

export const xhrErrorLog = (err: any, url: string, data: any) => error('[error 400]', '埋点上报接口请求报错', '\nurl:', url, '\ndata', data, '\nerror:', err || 'server decode log failed');

export const logXhrResponseCheck = (status: number, response: string, url: string, data: any) => {
    let err;
    if (status < 200 || (status >= 300 && status !== 304)) {
        const err = response || status || 'unknonw error';
    } else {
        try {
            const { exception, result, error_msg } = JSON.parse(response);
            if (exception) {
                err = exception;
            }
            if (result !== 1) {
                err = error_msg || `result is ${result}`
            }
        } catch (e){
            err = (e as Error).message;
        }
    }
    err && xhrErrorLog(err, url, data);
    return err;
}